import * as React from "react"
import { storyblokEditable, renderRichText } from "gatsby-source-storyblok"

const LuxuryAccommodations = ({ blok }) => {
  // console.log(blok)

  return (
    <div id="accommodations" className="pt-10">
      <div className="container max-w-[700px] mx-auto py-10 text-center">
        <h2 className="text-3xl font-bold">{blok.title}</h2>
        <div className="py-5">{blok.description}</div>
      </div>

      <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {
            blok.accommodations?.map((node, i) => {
              const content = node.content
              if (!content) return null
              
              return (
                <div className="flex flex-col" key={i} {...storyblokEditable(content)}>
                  {content.leftBannerImage && <img className={`w-full ${blok.keepImageRatio ? 'h-[265px] object-contain' : 'h-[250px] object-cover'}`} loading="lazy" src={`${content.leftBannerImage?.filename}/m/0x500`} alt={content.leftBannerImage?.alt} />}
                  <div className="py-5 text-center">
                    <h4 className="py-2">———  {content.region} ———</h4>
                    <h3 className="text-lg font-serif">{content.hotelName}</h3>
                  </div>
                  <div className="px-5" dangerouslySetInnerHTML={{ __html: renderRichText(content.overview) }}></div>
                  
                  <a href={`/${node.full_slug}`} className="text-blue-700 flex items-center mx-auto py-5">
                    Details <img className="w-8 h-3 align-middle ml-2" src="/icons/arrow-right-blue.svg" alt="Arrow right"/>
                  </a>
                </div>
              )
            })
          }
        
      </div>
    </div>)
}

export default LuxuryAccommodations
